import React from 'react'
import { AdvisorDetailProps, DirectAdvisorProps } from '../../utils/types'
import BaseAdvisorProfile from './BaseAdvisorProfile'
import capitalizeStatesInLocation from '../../utils/capitalizeStatesInLocation'
import getSecLinkLabel from '../../utils/getSecLinkLabel'

const DirectAdvisor = ({ advisor, position }: DirectAdvisorProps) => {
  const details: AdvisorDetailProps[] = [
    advisor.email && { title: 'Email', value: 'Click to Email', link: advisor.email, isEmail: true },
    advisor.phone && { title: 'Phone', value: advisor.phone, link: advisor.phone, isPhone: true },
    advisor.location && { title: 'Location', value: capitalizeStatesInLocation(advisor.location) },
    advisor.certifications && { title: 'Certifications', value: advisor.certifications },
    advisor.firm && { title: 'Firm', value: advisor.firm },
    advisor.firmCrd && { title: '', value: 'View Firm Disclosure Brochure', link: `https://adviserinfo.sec.gov/firm/brochure/${advisor.firmCrd}`, isExternal: true, hasIcon: true },
    advisor.sec_link && { title: 'Employment History', value: getSecLinkLabel(advisor.sec_link), link: advisor.sec_link, isExternal: true }
  ].filter(Boolean) as AdvisorDetailProps[]

  return <BaseAdvisorProfile advisor={advisor} details={details} position={position} />
}

export default DirectAdvisor
